import {message, Upload, Modal, notification} from "antd";
import React, {useEffect, useState} from "react";
import { Menus } from "../../../../assets";
import { fetchApi } from "../../../../_config/api";

export const UploadPhoto = ({
                                showUpload,
                                showLoader,
                                onSuccess,
                                onCancel,
                            }) => {
    const [fileList, setFileList] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const handleUpload = () => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const uploaded_image = reader.result;
            showLoader(true);
            const accessBody = {
                photo: uploaded_image,
            };
            fetchApi({
                url: "developer/update-photo",
                method: "PUT",
                data: accessBody,
            })
                .then((response) => {
                    notification.success({
                        message:"upload successfully.",
                        duration: 3,
                    });
                    onSuccess(response);
                })
                .catch((err) => {
                    // console.log(err);
                    notification.error({
                        message: "upload failed.",
                        duration: 3,
                    });
                })
                .finally(() => {
                    showLoader(false);
                });
        });
        reader.readAsDataURL(fileList[0].originFileObj);
        showLoader(false);
    };
    const handleChange = (info) => {
        let fileList = [...info.fileList];

        // 1. Limit the number of uploaded files
        // Only to show the last recent uploaded files, and old ones will be replaced by the new
        fileList = fileList.slice(-1);
        if(fileList.length > 0 && fileList[0].type === "image/png" || fileList[0].type === "image/jpeg") {
            setFileList(fileList);
        }
    };
    const onRemove = (file) => {
        console.log("file",file)
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
    };


    const handlePreview = () => {
        setPreviewImage(fileList[0].thumbUrl)
        setPreviewOpen(true)
    };

    const beforeUpload = (file) => {
        const isValid = file.type === "image/png" || file.type === "image/jpeg";
        if (!isValid) {
            notification.error({
                message: `${file.name} is not in a valid format. Please  upload png or jpeg format`,
                duration: 3,
            });
            setFileList([]);
        } else {
            setFileList([file]);
        }
        return false;
    };
    useEffect(() => {
        console.log("Updated fileList:", fileList);
    }, [fileList]);

    const onClose = () => {
        setFileList([]);
        onCancel();
    };
    const closeon = () => {
        setPreviewOpen(false)
    };
    return (
        <>
            <Modal title="" footer={null} closable={false} open={showUpload}>
                <div className="popup-request-container">
                    <div className="close-icon" onClick={onClose}>
                        <Menus type="close" />
                    </div>
                    <Upload
                        name="avatar"
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleChange}
                        onRemove={onRemove}
                        showUploadList={true}
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                    >
                        {fileList.length > 0 ? null : "Select Photo"}
                    </Upload>
                    <div className="mt-n4"><i className="ant-form-item-explain-warning">Acceptable file formats are image/png, image/jpeg files up to 10 MB.</i></div>
                    <div className="btn-section">
                        <button
                            className={`ok-btn`}
                            onClick={handleUpload}
                        >
                            Upload
                        </button>
                        <button onClick={onClose} className="cancel-btn">
                            Cancel
                        </button>
                    </div>
                </div>
                <Modal open={previewOpen} title={previewTitle} closable={false} footer={null}>
                    <div className="close-icon" onClick={closeon}>
                        <Menus type="close" />
                    </div>
                    <div style={{display:'flex',justifyContent:"center",justifyItems:'center'}}>
                        <img alt="example" style={{ width: 'auto' , height:'auto'}} src={previewImage} />
                    </div>
                </Modal>
            </Modal>
        </>
    );
};
